// Mock data for the Moodle Question Generator

export const SIDEBAR_TYPES = [
  { id: 'mc-single',   labelId: 'Multiple choice (single)',   labelEn: 'Multiple choice (single)' },
  { id: 'mc-multiple', labelId: 'Multiple choice (multiple)', labelEn: 'Multiple choice (multiple)' },
  { id: 'truefalse',   labelId: 'True/false',                 labelEn: 'True/false' },
  { id: 'short',       labelId: 'Short answer',               labelEn: 'Short answer' },
  { id: 'numerical',   labelId: 'Numerical response',         labelEn: 'Numerical response' },
  { id: 'matching',    labelId: 'Matching',                   labelEn: 'Matching' },
  { id: 'essay',       labelId: 'Essay',                      labelEn: 'Essay' },
];

// Groups of math/science symbols shown as a horizontal button toolbar
export const SYMBOL_GROUPS = [
  // Row 1 - powers, roots, fractions, calculus, greek
  ['x²','xʸ','xₓ','ˣ','ₓ','√x','a/b','∫','∑','π','log','sin','cos','SPL { }','∛','∬','∭','∮','(a)','[a]','{a}','|a₁ a₂|','α','β','γ','δ','ϵ','ζ','η','θ','λ','σ','ω','Γ','Δ','Φ','Ω','·','×','÷','±','∓','≤','≥','≠','∞','∈','∉','∀','∃','⊆'],
  // Row 2 - operators & relations
  ['⊇','≈','≡','∝','←','→','↑','↓','↔','⇐','⇒','⇔','↗','↘','↙','↖','limₓ→₀','∂','∇','dy/dx','tan','cot','sec','csc','arcsin','arccos','arctan','≡','∝','∴','∵','∨','∧','¬','ℕ','ℤ','ℚ','ℝ','ℂ','ℵ','ĀB','→v','∠ABC','△ABC','⊥','∥','≈','≅','⊕','⊗','∪','∩'],
  // Row 3 - chemistry & physics formulas
  ['H₂O','CO₂','O₂','NaCl','H⁺','OH⁻','H₂SO₄','Reaksi ⇌','ΔF = ma','E = mc²','v = u + at','s = ut + ½at²','V = IR','P = VI','λ = v/f','p = mv','W = Fd','ΔE = mcΔT'],
];

// Default empty question factory
export const createEmptyQuestion = (type, index = 1) => {
  const base = {
    id: `q_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    type,
    title: `${typeShortCode(type)}${String(index).padStart(2, '0')}`,
    question: '',
  };
  switch (type) {
    case 'mc-single':
      return { ...base, options: ['','','','',''], correct: 0 };
    case 'mc-multiple':
      return { ...base, options: ['','','','',''], corrects: [] };
    case 'truefalse':
      return { ...base, correct: 'true' };
    case 'short':
      return { ...base, answers: [''] };
    case 'numerical':
      return { ...base, answer: '', tolerance: '0' };
    case 'matching':
      return { ...base, pairs: [{ q:'', a:'' },{ q:'', a:'' },{ q:'', a:'' }] };
    case 'essay':
      return { ...base, sampleAnswer: '' };
    default:
      return base;
  }
};

export const typeShortCode = (type) => {
  const map = {
    'mc-single':   'MC',
    'mc-multiple': 'MCM',
    'truefalse':   'TF',
    'short':       'SA',
    'numerical':   'NUM',
    'matching':    'MT',
    'essay':       'ES',
  };
  return map[type] || 'Q';
};

export const typeLabel = (type, lang = 'id') => {
  const item = SIDEBAR_TYPES.find(s => s.id === type);
  if (!item) return type;
  return lang === 'en' ? item.labelEn : item.labelId;
};
